'use client';

export const formatToHourAndMinutes = (date: Date, locale: string): string =>
  date.toLocaleString(locale, { hour: 'numeric', minute: '2-digit' });
